import { computed, effect, signal } from '@preact/signals-react'
import { UserSettingsType } from '../../utils/constants'
import { getDateMinus30DaysComputed } from '../../utils/utils'

export const utgListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.UtgListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.UtgListFilters)): { Predicates: [] })
effect(() => {
    if (utgListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.UtgListFilters, JSON.stringify(utgListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.UtgListFilters)
    }
})
export const utgListFiltersCountSignal = computed(() => utgListFiltersValueSignal.value?.Predicates?.length || 0)

export const taskListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.TaskListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.TaskListFilters)): { Predicates: [{ "PropertyName": "TaskRunAfter", "Operator": "GT", "Value": getDateMinus30DaysComputed(), "TypeHint": "DateTime" }] })
effect(() => {
    if (taskListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.TaskListFilters, JSON.stringify(taskListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.TaskListFilters)
    }
})
export const taskListFiltersCountSignal = computed(() => taskListFiltersValueSignal.value?.Predicates?.length || 0)

export const deviceListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.DeviceListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.DeviceListFilters)): { Predicates: [] })
effect(() => {
    if (deviceListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.DeviceListFilters, JSON.stringify(deviceListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.DeviceListFilters)
    }
})
export const deviceListFiltersCountSignal = computed(() => deviceListFiltersValueSignal.value?.Predicates?.length || 0)

export const pageSizeSignal = signal(window.localStorage.getItem(UserSettingsType.PageSize) ? parseInt(window.localStorage.getItem(UserSettingsType.PageSize), 10) : 250)
effect(() => {
    window.localStorage.setItem(UserSettingsType.PageSize, pageSizeSignal.value)
})

export const showSidebarSignal = signal(window.localStorage.getItem(UserSettingsType.ShowTree) === 'true')
effect(() => {
    window.localStorage.setItem(UserSettingsType.ShowTree, showSidebarSignal.value)
})

// TODO: not implemented yet
export const sidebarWidthSignal = signal(window.localStorage.getItem(UserSettingsType.SidebarWidth) || 300)
effect(() => {
    window.localStorage.setItem(UserSettingsType.SidebarWidth, sidebarWidthSignal.value)
})

export const debugSignal = signal(window.localStorage.getItem(UserSettingsType.Debug) === 'true')
effect(() => {
    window.localStorage.setItem(UserSettingsType.Debug, debugSignal.value)
})

export const selectedBusinessEntityIdSignal = signal(window.localStorage.getItem(UserSettingsType.SelectedBusinessEntityId))
effect(() => {
    if (selectedBusinessEntityIdSignal.value) {
        window.localStorage.setItem(UserSettingsType.SelectedBusinessEntityId, selectedBusinessEntityIdSignal.value)
    }
    else {
        window.localStorage.removeItem(UserSettingsType.SelectedBusinessEntityId)
    }
})